import { Component, OnInit } from '@angular/core';
import { CommmonService } from 'src/app/utils/common.service';
import { CambioPlan, InfoModales, Plans } from 'src/app/home/models/plans.interface';
import { ActivatedRoute } from '@angular/router';
import { InfoModalPlanesService } from 'src/app/reference-data/service/infoPlanes.service';
import { EmployeeSap } from 'src/app/home/models/employee.interface';
import { EmployeesapService } from 'src/app/home/services/employeesap.service';

@Component({
  selector: 'app-cards-plans',
  templateUrl: './cards-plans.component.html',
  styleUrls: ['./cards-plans.component.scss'],
})
export class CardsPlansComponent implements OnInit {
  isDisabled = true;
  openModal = false;
  idPlanOpenModal?: number;
  descriptionDowngrade!: string | undefined;
  processDowngrade!: string | undefined ;
  descriptionUpgrade!:string | undefined;
  detailsUpgrade!:string | undefined; 
  plans!: Plans[];
  user_plan!: any;
  info_modales:InfoModales[]=[];
  imagen!:string | undefined;
  cambio!:CambioPlan;
  openModalAlert=false;
  employeeSap!: EmployeeSap;
  openModaldesaffiliation =false;

  downgradeToPlanDuo!:boolean;
  isEmployeeCopec = false;
  mensajeModalAlerta = ""
  iconoModalAlerta = ""

  
  constructor(
    private commonService: CommmonService,
    private route: ActivatedRoute,
    private infoModales:InfoModalPlanesService,
    private employeeSapService: EmployeesapService,
  ) {}


  async ngOnInit(){
    await this.isEmployeeSAP();
    await this.getplansInfo();

  }

  async getplansInfo() {
    this.user_plan = this.route.snapshot.data['resolve_user_plan'] ?? [];    
    this.commonService.removeItemLocalStorage('plans');
    this.plans = this.commonService.sortArray(
      this.route.snapshot.data['resolver_plans'] ?? [],
    );
    
    this.cambio = JSON.parse(this.route.snapshot.data['resolve_change_plan'] ?? {});  
    this.info_modales = await this.infoModales.GetInfoModales();  
    this.commonService.setItemLocalStorage('plans', JSON.stringify(this.plans));
  }

  async isEmployeeSAP() {
    try{
     this.employeeSap = await this.employeeSapService.getEmployeeSapByRut()
      this.isEmployeeCopec = true;   
    }catch(e){
      console.error('No es empleado SAP ', e)
    }
  }


 openModalPlanInfo(idplan: number) {
    this.idPlanOpenModal = idplan;
    this.downgradeToPlanDuo = this.user_plan.plan_id === 4 && idplan === 3;

    if (this.isEmployeeCopec) {
      const tipoContrato = this.employeeSap.colaborador.condiciones[0]?.contrato?.tipoContrato;

      if (tipoContrato === 'Plazo Fijo') {
        this.mensajeModalAlerta = "alertaContratoFijo";
        this.iconoModalAlerta = "alerta";
        this.openModalAlert = true;
        return;
      }

      const esUpgrade = idplan > this.user_plan.plan_id;
      if (esUpgrade || this.cambio.aplica_cambio_30_dias || this.cambio.aplica_cambio_cada_180_dias) {
        this.openModal = true;
        const dataModal = this.getInfoModalIdCards(idplan);
        this.imagen = dataModal?.pathImagen;

        if (idplan < this.user_plan.plan_id) {
          const downgrade = dataModal?.downgrade.find(x => x.idplan === this.user_plan.plan_id);
          this.descriptionDowngrade = downgrade?.descripcion;
          this.processDowngrade = downgrade?.detalle;
        } else {
          this.descriptionUpgrade = dataModal?.descripcion;
          this.detailsUpgrade = dataModal?.detalle;
        }
      } else {
        this.mensajeModalAlerta = "alerta6Meses";
        this.iconoModalAlerta = "alerta";
        this.openModalAlert = true;
      }

    } else {
      this.mensajeModalAlerta = 'alertaCambioSinSap';
      this.iconoModalAlerta = "alerta";
      this.openModalAlert = true;
    }
  }

  
  getInfoModalIdCards(idplanSelected:number){
    const info_modal = this.info_modales.find(x => x.id_plan === idplanSelected);
    return info_modal;    
  }

  closeModalInfo(update: boolean) {
    this.openModal = update;
    this.openModalAlert=update;
    this.openModaldesaffiliation = update;
  }
  

  goDesaffiliation(event:any){
    this.openModaldesaffiliation = event
  }
}

